import { Label } from '@cian/ui-kit';

import { FC } from 'react';

export type AdLabelProps = {
  label: string;
  /**
   * @deprecated Этот цвет — баг миграции, когда другие команды повысили версии ui-kit-design-tokens.
   * Использовали codemod, а он в зависимости от версии давал разные цвета, и в итоге корректный цвет стал некорректным.
   * Потом дизайнеры из других команд сказали, что это правильный цвет именно для их страниц,
   * но это в корне неверно. Пока разбираемся с лейблами, придётся это поддерживать.
   */
  theme?: 'deprecated';
};

export const AdLabel: FC<AdLabelProps> = ({ theme, label }) => {
  return (
    <Label
      data-testid="label"
      background={theme === 'deprecated' ? 'accent-ghost-primary' : 'overlay-default'}
      color="text-inverted-default"
    >
      {label}
    </Label>
  );
};
